import axios from "axios";
import { PaginatedAdminToolUsersDto } from "./models/AdminToolUserDto";

export const getToolUsers = async (
  toolKey: string,
  capabilityId: string,
  page: number,
  pageSize: number,
): Promise<PaginatedAdminToolUsersDto> => {
  const { data } = await axios.get<PaginatedAdminToolUsersDto>(
    `${window.configuration.apiUrl}api/users/admin/search/tool`,
    {
      params: {
        toolKey,
        capabilityId,
        page,
        pageSize,
      },
    },
  );

  return data;
};

export const exportToolUsers = async (
  toolKey: string,
  capabilityId: string,
): Promise<void> => {
  const response = await axios.get(
    `${window.configuration.apiUrl}api/users/admin/search/tool/export`,
    {
      params: {
        toolKey,
        capabilityId,
      },
      responseType: "blob",
    },
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const contentDisposition = response.headers["content-disposition"];
  let fileName = "users.csv";
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
    if (fileNameMatch && fileNameMatch.length === 2)
      fileName = fileNameMatch[1];
  }
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const syncToolUsers = async (
  toolKey: string,
  capabilityId: string,
): Promise<void> => {
  let response;
  try {
    response = await axios.get(
      `${window.configuration.apiUrl}api/Users/admin/sync/tool/export`,
      {
        params: {
          ToolKey: toolKey,
          CapabilityId: capabilityId,
        },
        responseType: "blob",
      },
    );
  } catch (error: unknown) {
    if (axios.isAxiosError(error) && error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let message = `Sync failed (${error.response.status})`;
      try {
        const parsed = JSON.parse(text);
        message = parsed?.detail ?? parsed?.title ?? parsed?.message ?? text;
      } catch {
        message = text || message;
      }
      throw new Error(message);
    }
    throw error;
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const contentDisposition = response.headers["content-disposition"];
  let fileName = "sync-users.csv";
  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
    if (fileNameMatch && fileNameMatch.length === 2)
      fileName = fileNameMatch[1].trim();
  }
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
